'use strict';
const {assignEvent, noop} = require('./util');

class FocusMode {
    _config = {};
    _element = undefined;
    _event = noop;
    _currentFocusIdleTime = 0;
    _mouseIdleInterval = undefined;

    constructor(element, config) {
        this._element = element;
        this._config = {...FocusMode.defaults, ...config};
    }

    _mouseIdle() {
        const {idleTime} = this._config;
        if (this._element.dataset.focusedDisabled === 'true') {
            this._currentFocusIdleTime = 0;
            return;
        }
        this._toggleFocusMode();

        if (this._currentFocusIdleTime > idleTime) return;
        this._currentFocusIdleTime++;
    }
    _toggleFocusMode() {
        const enabled = this._currentFocusIdleTime >= this._config.idleTime;
        this._element.dataset.focused = String(enabled);
    }

    init() {
        const {_config, _element} = this;
        const supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
        if (_config.enabled) {
            if ((supportsTouch && !_config.disableTouch) || !supportsTouch) {
                this._mouseIdleInterval = setInterval(this._mouseIdle.bind(this), _config.intervalTime);
                this._event = assignEvent(_element, ['mousemove', 'touchend', 'keydown', 'click'], () => {
                    this._currentFocusIdleTime = 0;
                    this._toggleFocusMode();
                });
            }
        }
    }

    destroy() {
        this._event();
        this._mouseIdleInterval && clearInterval(this._mouseIdleInterval);
    }
}

FocusMode.defaults = {
    enabled: true,
    disableTouch: true,
    idleTime: 5,
    intervalTime: 1000,
};

module.exports = FocusMode;
